import { useEffect } from 'react';

/**
 * Full-screen image preview: dark backdrop, tap/click anywhere or Escape to
 * close. Shared by the conduct page's attachment chips and the audit
 * record's photo readback.
 */
export function ImageLightbox({
  src,
  alt,
  onClose,
}: {
  src: string;
  alt: string;
  onClose: () => void;
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="attach-preview-backdrop" onClick={onClose}>
      <img src={src} alt={alt} />
      <button
        type="button"
        className="attach-preview-close"
        aria-label="Close preview"
        onClick={onClose}
      >
        ✕
      </button>
    </div>
  );
}
